module.exports = __webpack_public_path__ + "static/media/29ADMSPC36.707246e0.jpg";